module.exports = __webpack_public_path__ + "assets/images/96bc57ab81fbb94cb46708442959a976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/camerama/camerama-0.jpg
// module id = 802
// module chunks = 0